import * as React from "react"
import './header.scss'
import { useDispatch, useSelector } from "react-redux"
import { appActions } from "../../actions"
import * as AppTypes from "AppTypes"
import getStepConfig from "../../views/stepConfig"

const Header: React.FC = () => {
    const dispatch = useDispatch()

    const { artistInfo, step, activeCountry, langPack } = useSelector((store: AppTypes.ReducerState) => {
        const { artistInfo = {} } = store.userInfo
        const step = store.app.step
        const activeCountry = store.userInfo.activeCountry
        const langPack = store.config.langPack
        return { artistInfo, step, activeCountry, langPack }
    })

    const { prevStep, progress } = getStepConfig()
    const gotoPrevStep = () => {
        dispatch(appActions.gotoStep(prevStep))
    }

    const countryList = {
        "SG": langPack["countrySG"],
        "TH": langPack["countryTH"],
        "MY": langPack["countryMY"],
        "ID": langPack["countryID"],
        "VN": langPack["countryVN"]
    }

    return <div className="header header--sticky info">
        <div>
            {prevStep && <div className="header__back-icon" onClick={gotoPrevStep}></div>}
        </div>
        <div className="header__text">
            <div className='header__title'>{langPack["competitionTitle"]}</div>
            <div className='header__sub-title'>{countryList[activeCountry]}</div>
            {(step === "Dashboard" || step === "EntryEditor")
                && artistInfo.artistStatus
                && <div className="header__category">
                    {artistInfo.artistStatus === "emerging" && langPack["emergingCategory"]}
                    {artistInfo.artistStatus === "established" && langPack["establishedCategory"]}
                </div>}
        </div>
        <div
            key="progressBar"
            className="progress-bar"
            style={{
                width: progress ? progress + "%" : 0
            }}
        />
    </div>
}

export default Header